import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {CheckboxFilterOption} from "./checkbox-filter-option";
import {Overlayable} from "../../interfaces/overlayable";
import {Store} from "@ngrx/store";
import {AppState} from "../../store";
import {setUpdateArchiveView, toggleJobFilterValue} from "../../store/actions/filter.actions";
import {getFilterByKey} from "../../store/selectors/filter.selector";
import {UntilDestroy, untilDestroyed} from "@ngneat/until-destroy";

@UntilDestroy()
@Component({
  selector: 'brt-checkbox-filter',
  templateUrl: './checkbox-filter.component.html',
  styleUrls: ['./checkbox-filter.component.scss']
})
export class CheckboxFilterComponent implements Overlayable, OnInit, OnDestroy {

  @Input('options') options: CheckboxFilterOption[] = [];
  @Input('settingsKey') settingsKey: string = "";
  @Output('onClosed') onClosed = new EventEmitter<boolean>();

  constructor(
    private store: Store<AppState>
  ) {}



  toggleOption(id: number) {
    // console.log({key: this.settingsKey, value: id});
    this.store.dispatch(toggleJobFilterValue({key: this.settingsKey, value: id}));
  }

  ngOnInit() {
    console.warn(this.settingsKey);
    //console.log(this.options);

    this.store.select(getFilterByKey(this.settingsKey)).pipe(untilDestroyed(this)).subscribe((val) => {
      this.options = this.options.map((el) => {
        return {
          ...el,
          selected: val.includes(el.id)
        }
      })
    });
  }

  ngOnDestroy() {
    this.store.dispatch(setUpdateArchiveView({updateActive: true}));
  }

  identify(index: any, item: any) {
    return item.id;

  }
}
